import React, { Component } from "react";
import { Card, Table, BackTop } from "antd";
import { connect } from "react-redux";
import { req_list_gam_graduateClass } from "../../api";
import { usrRole } from "../../utils/dataUtil";

import "./graduatefresh.css";
class GraduateClass extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    userLevel: "NORMAL",
    loading: false,
    items: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_list_gam_graduateClass(userCode, userLevel, token);
    this.setState({ loading: false });
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
    }
  };

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "NowAcademicYear",
        width: 40,
        //align: 'center',
        responsive: ["lg"],
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 50,
        responsive: ["lg"],
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 70,
        responsive: ["lg"],
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        className: "resultColumns",
        responsive: ["md"],
        width: 100,
        render: (text, record) => (
          <div title={record.DepartmentName} className="resultColumnsDiv">
            {record.DepartmentName}
          </div>
        ),
      },
      {
        title: "班級",
        dataIndex: "ClassGradeName",
        width: 90,
      },
      {
        title: "班導",
        dataIndex: "ClassTeacherName",
        width: 70,
      },
      {
        title: () => (
          <div
            style={{
              color: "gold",
            }}
          >
            班級人數
          </div>
        ),
        dataIndex: "GraduateAllTotal",
        fixed: "right",
        width: 60,
        align: "right",
        render: (text, record) => (
          <div title={record.GraduateAllTotal}>{record.GraduateAllTotal}</div>
        ),
      },
      {
        title: () => <span style={{ color: "gold" }}>已填</span>,
        dataIndex: "GraduateComfirmTotal",
        fixed: "right",
        width: 40,
        align: "right",
        render(text, record) {
          return {
            props: {
              style: {
                background:
                  record.GraduateComfirmTotal === record.GraduateAllTotal
                    ? "palegreen"
                    : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.GraduateComfirmTotal}
                style={{
                  color: "Green",
                  fontWeight: "Bold",
                }}
              >
                {record.GraduateComfirmTotal}
              </div>
            ),
          };
        },
      },
      {
        title: () => <div style={{ color: "gold" }}>未填</div>,
        dataIndex: "StatusACount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render(text, record) {
          return {
            props: {
              style: {
                background:
                  record.GraduateComfirmTotal === record.GraduateAllTotal
                    ? "palegreen"
                    : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.StatusACount}
                style={{
                  color: "Red",
                  fontWeight: "Bold",
                }}
              >
                {record.StatusACount}
              </div>
            ),
          };
        },
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>就業</div>,
        dataIndex: "StatusBCount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusBCount}>{record.StatusBCount}</div>
        ),
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>服役</div>,
        dataIndex: "StatusCCount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusCCount}>{record.StatusCCount}</div>
        ),
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>升學</div>,
        dataIndex: "StatusDCount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusDCount}>{record.StatusDCount}</div>
        ),
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>留學</div>,
        dataIndex: "StatusECount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusECount}>{record.StatusECount}</div>
        ),
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>待業</div>,
        dataIndex: "StatusGCount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusGCount}>{record.StatusGCount}</div>
        ),
      },
      {
        title: () => <div style={{ color: "GreenYellow" }}>其他</div>,
        dataIndex: "StatusFCount",
        width: 40,
        responsive: ["md"],
        align: "right",
        render: (text, record) => (
          <div title={record.StatusFCount}>{record.StatusFCount}</div>
        ),
      },
    ];
  };

  render() {
    const { loading, items } = this.state;
    return (
      <Card>
        <Table
          className="detectListTable"
          bordered
          scroll={{ y: 480 }}
          pagination={{ pageSize: 50 }}
          loading={loading}
          rowKey="ClassGradeCode"
          dataSource={items}
          columns={this.columns}
        ></Table>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(GraduateClass);
